import Header from "../../Header/Header";
import logo from "../../../assets/logoa 1.png";
import { useState } from "react";
import OtpInput from "react-otp-input";
import {
  CreateVerifyCode,
  sendVerifyCode,
} from "../../../services/kojaServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const UserLogin = () => {
  const [type, setType] = useState("login");
  const [otp, setOtp] = useState("");
  const [mobileNumber, setMobile] = useState();
  const navigate = useNavigate();

  const sendMobile = async () => {
    try {
      let mobile = document.getElementById("mobile").value;
      const phoneRegExp =
        /^09(0[0-9]|1[0-9]|3[0-9]|2[0-9])-?[0-9]{3}-?[0-9]{4}$/;
      if (mobile && phoneRegExp.test(mobile)) {
        let sendData = { mobile, deviceId: "" };
        const { status } = await CreateVerifyCode(sendData);
        if (status === 200) {
          setType("Authentication");
          setMobile(mobile);
        }
      } else {
        toast.error("لطفا شماره تلفن خود را به طور صحیح وارد کنید");
      }
    } catch (err) {
      console.log(err);
      toast.error("خطایی رخ داده است مجدد تلاش کنید");
    }
  };

  const sendCode = async () => {
    try {
      console.log(mobileNumber);
      let sendData = { mobile: mobileNumber, code: otp };
      const { data } = await sendVerifyCode(sendData);
      console.log(data);
      localStorage.setItem("token", data.result.token);
      navigate("/user/request");
    } catch (err) {
      console.log(err.response.status);
      if (err.response.status) {
        toast.error("کد وارد شده صحیح نمی باشد");
      } else {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
      }
    }
  };
  return (
    <div className="user-login">
      <Header />
      {type === "login" ? (
        <div className="user-login-box1 text-center">
          <img alt="" className="user-login-logo" src={logo} />
          <div className="user-login-box2">
            <h3 className="user-login-label">ورود کاربر</h3>
            <input
              placeholder="شماره تماس"
              type="number"
              id="mobile"
              className="userlogin-input"
            />
            <div className="user-login-btn-box">
              <button
                className="btn user-login-btn "
                onClick={() => {
                  sendMobile();
                }}
              >
                دریافت کد یک بار مصرف
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="user-login-box1 text-center">
          <div className="user-login-box2">
            <h3 className="user-login-label mb-4">اهراز هویت</h3>
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={4}
              inputStyle={{
                width: "70px",
                height: "40px",
                borderRadius: "30px",
                border: "none",
              }}
              containerStyle={{ direction: "ltr" }}
              renderSeparator={<span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>}
              renderInput={(props) => <input {...props} />}
            />
            <div className="user-login-btn-box">
              <button
                className="btn user-login-btn "
                onClick={() => {
                  sendCode();
                }}
              >
                ورود
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserLogin;
